import React, { useCallback } from 'react';
import CommonCheckbox from '../../common-checkbox/CommonCheckbox';

const TdCheckbox = ({ selected, onSelect }) => {
  const toggleAll = useCallback(() => {
    onSelect();
  }, [onSelect]);

  return (
    <div className='td cell-btn'>
      <CommonCheckbox checked={selected} onChange={toggleAll} />
    </div>
  );
};

export default TdCheckbox;
